// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__32GvH","inputWrap":"CustomTip_inputWrap__Hascq"};